import { Box, Container, Typography } from "@mui/material";

import GlossaryTable from "./Glossary.table";

const Glossary = () => {
  return (
    <Container maxWidth="xl">
      <Box mt={3}>
        <Typography variant="h2">Training Center</Typography>
      </Box>
      <Box mt={3}>
        <Typography variant="h4" sx={{ my: 1 }}>
          Glossary
        </Typography>
        <GlossaryTable />
      </Box>
    </Container>
  );
};

export default Glossary;
